import React from 'react';

export function ChevronRightIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M16.166 12.7459L9.16602 18.9959C8.75405 19.3638 8.12189 19.328 7.75406 18.916C7.38623 18.5041 7.42201 17.8719 7.83398 17.5041L13.9985 12L7.83398 6.49595C7.42201 6.12812 7.38623 5.49596 7.75406 5.08399C8.12189 4.67202 8.75405 4.63624 9.16602 5.00407L16.166 11.2541C16.6113 11.6517 16.6113 12.3483 16.166 12.7459Z" />
    </svg>
  );
}